import React, { Component } from 'react';
import Banner from '../components/common/Banner';

export default class Product extends Component {
    render() {
        return (
            <div>
                {/* Page Title */}
                <Banner title={"Our Products"} desc={"Explore Bhoomi Rocks Products"} img={"images/bg/bg_1.jpg"} />

                {/* Products Section */}
                <section className="section product-page py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <h2 className="title-color mb-4">Premium Stones & Minerals</h2>
                                <p className="mb-5">
                                    At Bhoomi Rocks Products, we specialize in prospecting, processing, and delivering high-quality natural stones, minerals, and allied materials for construction, landscaping, and decorative purposes. Explore our curated selection below.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            {[
                                {
                                    img: "images/products/granite.jpg",
                                    title: "Granite",
                                    desc: "Durable, versatile granite stones for construction, decorative uses."
                                },
                                {
                                    img: "images/products/marble.jpg",
                                    title: "Marble",
                                    desc: "Elegant marble stones for luxurious interiors, architectural designs."
                                },
                                {
                                    img: "images/products/sandstone.jpg",
                                    title: "Sandstone",
                                    desc: "Natural sandstone for landscaping, outdoor construction projects."
                                },
                                {
                                    img: "images/products/minerals.jpg",
                                    title: "Specialty Minerals",
                                    desc: "High-quality minerals, aggregates for industrial, decorative applications."
                                }
                            ].map((product, index) => (
                                <div key={index} className="col-lg-3 col-md-6 mb-4">
                                    <div className="product-block-item text-center border rounded shadow-sm p-4 h-100">
                                        <h4 className="mt-3">{product.title}</h4>
                                        <p className="text-muted">{product.desc}</p>
                                        <a href="/contact" className="btn btn-main btn-round-full btn-sm">Inquire Now</a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Call to Action */}
                <section className="section text-center py-5 bg-light">
                    <div className="container">
                        <h2 className="mb-4">Ready to Transform Your Project?</h2>
                        <p className="mb-4">
                            Contact Bhoomi Rocks Products to discuss your needs and discover how our premium stones and minerals can elevate your construction or landscaping project.
                        </p>
                        <a href="/contact" className="btn btn-main btn-round-full mx-2">Get in Touch</a>
                    </div>
                </section>
            </div>
        );
    }
}